var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"center"}},[_c('baidu-map',{staticStyle:{"height":"6rem","width":"12.2rem","padding":"0.1rem"},attrs:{"center":_vm.center,"zoom":_vm.zoom,"scroll-wheel-zoom":true},on:{"ready":_vm.handler,"click":_vm.getClickInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }